import { Button } from '@radix-ui/themes'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import TestPathway from './TestPathway'
import TestPathwayDrawer from './TestPathwayDrawer'
import { useAuth } from 'hooks/useAuth'

function TestPathwayButton({
  disabled,
  elements,
  setChatInstanceCount,
  setShowChatInterface,
  chatStartNode,
  chatRequestData,
  setChatStartNode,
  setChatRequestData,
  chatEndpoint,
  setChatEndpoint,
  enableQA,
  setEnableQA,
  versions,
  chatVersion,
  setChatVersion,
  onTest,
}) {
  const [searchParams] = useSearchParams()
  const [isOpen, setIsOpen] = useState(false)
  const { org } = useAuth()
    const useDrawer = searchParams.get('useDrawer') === 'true' || org?.placement_group === "psg"

  const commonProps = {
    disabled,
    elements,
    setChatInstanceCount,
    setShowChatInterface,
    chatStartNode,
    chatRequestData,
    setChatStartNode,
    setChatRequestData,
    chatEndpoint,
    setChatEndpoint,
    enableQA,
    setEnableQA,
    versions,
    chatVersion,
    setChatVersion,
    isOpen,
    onClose: () => setIsOpen(false),
    onTest,
  }

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        size="2"
        variant="soft"
        color="gray"
        style={{ cursor: 'pointer' }}
        disabled={disabled}
      >
        Test Pathway
      </Button>

      {useDrawer
        ? (
            <TestPathwayDrawer {...commonProps} />
          )
        : (
            <TestPathway {...commonProps} />
          )}
    </>
  )
}

export default TestPathwayButton
